import {excelColumnHeaderForNewItem, excelColumnHeaderForPartMatching} from '../serviceRequests/readImportedFile'
import {ItemOrganization} from '../../item/model/ItemOrganization'
import {ServiceRequestWorkflowInput} from '../serviceRequests/model/ServiceRequestWorkflowInput'
import {ClassificationNode, FileDocument} from '../../displaySet/model/AttributeValue'

export interface NewItemInput {
    [excelColumnHeaderForNewItem.partNumber]: string;
    [excelColumnHeaderForNewItem.orgName]?: string;
    [excelColumnHeaderForNewItem.itemName]: string;
    [excelColumnHeaderForNewItem.itemDescription]: string;
    [excelColumnHeaderForNewItem.manufacturerId]: string;
}


export class NewItemInputDTO {
    partNumber: string
    organizationName?: string
    description: string
    linkedManufacturerItemId: string
    itemName: string

    constructor(item: NewItemInput) {
        this.partNumber = item[excelColumnHeaderForNewItem.partNumber]
        this.organizationName = item[excelColumnHeaderForNewItem.orgName] ?? ''
        this.description = item[excelColumnHeaderForNewItem.itemDescription]
        this.linkedManufacturerItemId = item[excelColumnHeaderForNewItem.manufacturerId]
        this.itemName = item[excelColumnHeaderForNewItem.itemName]
    }
}

export interface ItemMatchingInput {
    PART_NUMBER: string
    ORG_NAME: string
}

export class ItemMatchingInputDTO {
    partNumberIn: string
    manufacturerIn: string

    constructor(item: ItemMatchingInput) {
        this.partNumberIn = item[excelColumnHeaderForPartMatching.partNumber]
        this.manufacturerIn = item[excelColumnHeaderForPartMatching.orgName]
    }
}

export const ServiceFields = {
    EvidenceDocuments: 'EvidenceDocuments',
    EndOfLifeStatus: 'EndOfLifeStatus',
    ExportControlClassification: 'ExportControlClassification',
    EnvironmentalRegulation: 'EnvironmentalRegulation',
    UnderNonDisclosureAgreement: 'Under Non Disclosure Agreement',
    Comments: 'Comments'
} as const

export interface ItemCreationForm {
    partNumber: string
    technicalClassificationNode?: ClassificationNode
    definedByOrganization?: ItemOrganization
    organizationInput: string,
    [ServiceFields.EvidenceDocuments]: EvidenceDocumentsType,
    [ServiceFields.EndOfLifeStatus]?: EndOfLifeStatusType,
    [ServiceFields.ExportControlClassification]?: ExportControlClassificationType
    [ServiceFields.EnvironmentalRegulation]: EnvironmentalRegulationType[]
    [ServiceFields.Comments]: string
}

export const ServiceFieldDefinitions = {
    EvidenceDocuments: '3447c4d6-4838-4c75-8b96-3e9fb920760a',
    EndOfLifeStatus: '6386e7b6-2f76-4df4-bf76-1f1f2ccc9028',
    ExportControlClassification: 'ba6dbe34-b80d-4d82-874a-a61e2556a6cd',
    EnvironmentalRegulation: '50d065d4-cfa4-4706-bdff-aff353e67072',
    Comments: 'e3c3b071-988b-46d3-a007-1d7a8569fa22'
} as const

export type EvidenceDocumentsType = {
    proofs: FileDocument[]
}

export type EndOfLifeStatusType = {
    date?: string,
    proofs: FileDocument[]
}

export const ExportControlClassificationTypes = {
    DoubleUsage: 'Double Usage',
    ITAR: 'ITAR',
    Military: 'Military',
    EAR999: 'EAR (EAR99)',
    NotControlled: 'Not Controlled'
} as const

export type ExportControlClassificationType = {
    type?: (typeof ExportControlClassificationTypes)[keyof typeof ExportControlClassificationTypes],
    proofs: FileDocument[]
}


export const EnvironmentalRegulationTypes = {
    REACH_33: 'EU REACH Article 33',
    ROHS: 'EU ROHS',
    RADIO: 'EU Radioprotection',
    ODS: 'EU ODS',
    FLUORINATED_GHG: 'EU Fluorinated GHG',
    ASBESTOS: 'EU REACH entry 6 - Asbestos',
    ORGANIC_POLLUANTS: 'EU Persistent Organic Polluants',
    REACH_XVII: 'EU REACH - Annex XVII',
    MERCURY: 'EU Mercury',
    BIOCID: 'EU Biocid'
} as const

export type EnvironmentalRegulationType = {
    type?: (typeof EnvironmentalRegulationTypes)[keyof typeof EnvironmentalRegulationTypes],
    proofs: FileDocument[]
}
